module.exports = __webpack_public_path__ + "static/media/galerija_2019 (8).960820cf.jpg";